import { Carousel, Modal } from "react-bootstrap";

export default function ViewItemModal({
  showImages,
  setShowImages,
  carousel,
  setCarousel,
}) {
  if (!carousel) {
    return <></>;
  }

  const handleClose = () => {
    setShowImages(false);
    setCarousel(null);
  };

  return (
    <>
      <Modal
        style={{ display: "none" }}
        show={showImages}
        onHide={handleClose}
        size="xl"
        centered
      >
        <Modal.Header closeButton />
        <Modal.Body style={{ padding: "0px" }}>
          <Carousel variant="light" interval={null} fade>
            {carousel &&
              carousel.map((url) => (
                <Carousel.Item key={url.slice(url.lastIndexOf("=") + 1)}>
                  <img className="d-block w-100" src={url} alt="slide" />
                </Carousel.Item>
              ))}
          </Carousel>
        </Modal.Body>
      </Modal>
    </>
  );
}
